import { isEmpty } from '@sgme/fp';
import type { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { agMultiColumnFilter } from 'components/shared/Blotter/Grid/Hooks/utils';
import { useCallback, useMemo } from 'react';

const useValueFormatter = () => {
  return useCallback(({ value }: ValueFormatterParams) => {
    if (isEmpty(value)) {
      return '';
    }

    return value.join(', ');
  }, []);
};
export function useStringArrayColumnType<T>(handleValuesUpdate: boolean = false): ColTypeDef<T> {
  const valueFormatter = useValueFormatter();
  return useMemo(
    () => ({
      valueFormatter,
      ...agMultiColumnFilter(handleValuesUpdate),
    }),
    [handleValuesUpdate, valueFormatter],
  );
}
